import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface FilterState {
	location: string[];
	startDate: string;
	endDate: string;
	plan: string[];
	dimension: string;
	loader: boolean;
}

const initialState: FilterState = {
	location: [],
	startDate: "",
	endDate: "",
	plan: [],
	dimension: "",
	loader: false,
};

const filterSlice = createSlice({
	name: "filter",
	initialState,
	reducers: {
		setFilter: (state, action: PayloadAction<FilterState>) => {
			return {...state, ...action.payload};
		},
		resetFilter: () => initialState,
		setFilterLoader: (state, action: PayloadAction<boolean>) => {
			state.loader = action.payload;
		},
	},
});

export const {setFilter, resetFilter, setFilterLoader} = filterSlice.actions;
export default filterSlice.reducer;
